import { AnimatePresence, motion } from 'framer-motion'
import React, { useEffect } from 'react'

import DailyPrice from './prices/daily'
import MonthlyPrice from './prices/monthly'

const MotionFees = ({
  isOpen,
  isAnimate,
  onAnimateToggle,
}: {
  isOpen: boolean
  isAnimate: boolean
  onAnimateToggle: () => void
}) => {
  useEffect(() => {
    let timer: NodeJS.Timer

    if (isOpen) {
      timer = setInterval(() => onAnimateToggle(), 3000)
    }

    return () => {
      clearInterval(timer)
    }
  }, [isAnimate, isOpen])

  return (
    <AnimatePresence initial={false}>
      <>
        <motion.div
          key={`${isAnimate}`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
        >
          {isAnimate ? <DailyPrice /> : <MonthlyPrice />}
        </motion.div>
      </>
    </AnimatePresence>
  )
}

export default MotionFees
